import { TextField } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import CustomCard from "../../../components/CustomCard";
import { GenericFunction } from "../../../types/generic.types";

const Videos: FC<VideosProps> = ({ onChangeVideos, videosValue, setError }) => {
  const [videos, setVideos] = useState<[] | string>([]);

  const handleVideosData = (e: any, isDefaultValue = false) => {
    const videosValue: any = isDefaultValue ? e : e.target.value;
    if (videosValue.trim()) {
      let videosArray = videosValue.replace("\n", "").split(",");
      videosArray = videosArray.map((video: string) => {
        return { src: video, path: "" };
      });
      onChangeVideos(videosArray);
      setVideos(videosArray);
    } else {
      onChangeVideos([]);
      setVideos([]);
    }
  };

  useEffect(() => {
    if (videosValue) {
      const videosSrcs = videosValue.map((video: any) => {
        return video.src;
      });
      handleVideosData(videosSrcs.toString(), true);
      setVideos(videosSrcs.toString());
    }
  }, []);

  useEffect(() => {
    setError(videos.length > 0);
  }, [videos]);

  return (
    <CustomCard title="Videos (use comma for multiple links)">
      <TextField
        onChange={handleVideosData}
        id="outlined-multiline-static"
        label="Videos"
        multiline
        rows={4}
        defaultValue={videos}
        variant="outlined"
        fullWidth
      />
    </CustomCard>
  );
};

interface VideosProps {
  onChangeVideos: GenericFunction;
  videosValue?: [];
  setError: GenericFunction;
}

export default Videos;
